import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormBackend } from "./c005-bookingform-backend";

export class dealsResult {
	private $dealsResultError:Array<string> = [];
	private bookingFormCommon = new bookingFormCommon();
	private bookingFormBackend = new bookingFormBackend();
	$scope:any = $('#deals-popup');
	$passengerDetailsActive:any = $('#passenger-details--deals');

	/**
	 * Passenger details container
	 * @return {any} [description]
	 */
	passengerDetails(): any{
		let _self = this;	
		let $ticketAdultInput:number  = 1;
		let $ticketTeenagerInput:number  = 0;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalPassenger:any     = _self.$scope.find('.total-passengers');
		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('.total-nos').html($totalTickets);

		// declare passenger input variables
		// scope them to prevent multiple elements from being retrieved
		// (deals component uses the same class name for its inputs)
		let $adultInput  = _self.$passengerDetailsActive.find('.ticket-adult--input');
		let $infantInput = _self.$passengerDetailsActive.find('.ticket-infant--input');
		let $childInput = _self.$passengerDetailsActive.find('.ticket-child--input');
		let $teenagerInput = _self.$passengerDetailsActive.find('.ticket-teeanager--input');
		// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-youth--input');

		let $groupBooking     = _self.$scope.find('.group-booking');
		$groupBooking.hide();

		_self.$scope.find('.ticket-nos-btn').click(function(e:any) {
			e.preventDefault();

			let $adultBookingErr  = _self.$scope.find('.adult-booking--error');
			let $infantBookingErr = _self.$scope.find('.infant-booking--error');
			let $groupBooking     = _self.$scope.find('.group-booking');
			
			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = $("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					if (type == 'minus') {
							if (currentVal > input.attr('min')) {
									input.val(currentVal - 1).change();
							}
							if (parseInt(input.val()) == input.attr('min')) {
									$(this).attr('disabled', true);
							}
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1).change();
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
					}
			} else {
					input.val(0);
			}


			// retrieve all input values after calculation complete
			let $adultInputVal:string  = $adultInput.val();
			//let $youthInputVal:string  = $youthInput.val();
			let $childInputVal:string  = $childInput.val();
			let $infantInputVal:string = $infantInput.val();
			let $teenagerInputVal:string = $teenagerInput.val();
			if ($(this).attr('id') === 'btn-adult-minus-deals' || $(this).attr('id') === 'btn-adult-plus-deals') {
				$ticketAdultInput = parseInt($adultInputVal);
				if ($adultInputVal < $infantInputVal) {
					$adultBookingErr.show();
				} else {
					$infantBookingErr.hide();
					$adultBookingErr.hide();
				}
			}

			// if ($(this).attr('id') === 'btn-youth-minus' || $(this).attr('id') === 'btn-youth-plus') {
			//     $ticketYouthInput = parseInt($youthInputVal);
			// }
			if ($(this).attr('id') === 'btn-teenager-minus-deals' || $(this).attr('id') === 'btn-teenager-plus-deals') {
					$ticketTeenagerInput = parseInt($teenagerInputVal);
			}

			if ($(this).attr('id') === 'btn-child-minus-deals' || $(this).attr('id') === 'btn-child-plus-deals') {
					$ticketChildInput = parseInt($childInputVal);
			}

			if ($(this).attr('id') === 'btn-infant-minus-deals' || $(this).attr('id') === 'btn-infant-plus-deals') {
				$ticketInfantInput = parseInt($adultInputVal);
				if ($infantInputVal > $adultInputVal) {
					$infantBookingErr.show();
				} else {
					$infantBookingErr.hide();
					$adultBookingErr.hide();
				}
			}

			let $totalTickets = $ticketAdultInput + $ticketChildInput+$ticketTeenagerInput;
			let $totalPassengersVal:any = $totalTickets + $ticketInfantInput;

			_self.$scope.find('.total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalTickets);
			let $isEnableNinePass: any	=	$('#isEnableNinePass');
			//10930 - PROD > MH.com > More than 9 passengers link is not appearing for other site edition
			if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9)) {
			// if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9) && (window.location.href.indexOf('/my/') > 0)) {			
				$groupBooking.show();
			} else {
				$groupBooking.hide();
			}
			if ($totalTickets >= 2) {
				$totalPassenger.find('.type').html('Passengers');
			} else {
				$totalPassenger.find('.type').html('Passenger');
			}

			if (_self.$scope.find('.total-tickets--value').val() >= 9) {
				_self.$scope.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				_self.$scope.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				 _self.$scope.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				_self.$scope.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				_self.$scope.find('.child-nos .input-group--btn .plus').attr('disabled', false);
				_self.$scope.find('.teenager-nos .input-group--btn .plus').attr('disabled', false);
			}
		});

		_self.$scope.find('.minus-plus-input').attr('readonly', true);
		_self.$scope.find('.minus-plus-input').focusin(() => {
			 $(this).data('oldValue', $(this).val());
		});

		_self.$scope.find('.minus-plus-input').change(function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				_self.$scope.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
			} else {
				$(this).val($(this).data('oldValue'));
			}
			if (valueCurrent <= maxValue) {
				_self.$scope.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
			} else {
				$(this).val($(this).data('oldValue'));
			}
		});

		_self.$scope.find('.minus-plus-input').keydown(function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
	}

	/**
	 * Calendar component for single trip and multi city trip
	 * @return {any} [description]
	 */
	calendarComponent(): void {
		let _self = this;

		let $ibeNowDate:any      = new Date();
		let $ibeTodayDate:any    = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate(), 0, 0, 0, 0);
		let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
		let $ibeMaxLimitDate: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
		let $calStartDate:any    = new Date($('.departureDate').datepicker('getDate'));
		let $calEndDate:any      = new Date($('.returnDate').datepicker('getDate'));

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		let $highlightDays:any = (date: any) => {
			if (_self.$scope.find('.trip-type').text() == 'Return') {
				// format date field to include highlights
				var startDate:any = new Date($('.departureDate').datepicker('getDate'));
				var endDate:any   = new Date($('.returnDate').datepicker('getDate'));

				var modClasses:string = '';
				var modAltText:string = '';

				if ((startDate <= date) && (date <= endDate)) {
					modClasses += 'ui-state-selected';
					modAltText = 'Trip dates';
				}

				// highlight departure date
				if (Date.parse(startDate) == Date.parse(date)) {
					// console.log('start date match');
					modClasses += ' ' + 'ui-state-departureDate';
					modAltText = 'Departure date';
				}

				// highlight return date
				if (Date.parse(endDate) == Date.parse(date)) {
					// console.log('end date match');
					modClasses += ' ' + 'ui-state-returnDate';
					modAltText = 'Return date';
				}

				return [true, modClasses, modAltText];

			} else {
				// return date field as per normal
				return [true, '', 'Trip dates'];
			}

		}
		var $ipad_not:any;
		if (navigator.userAgent.match(/iPad/i)) {				
		$ipad_not=1;
		} else {
		$ipad_not=2;
		}
// Single trip calendar - return trip
		let $dateFormat:any = 'd M yy';

		let $departDate = _self.$scope.find('.departureDate').datepicker({
			showButtonPanel: true,
			closeText:      '<i class="fa fa-times" aria-hidden="true"></i>',
			minDate:      	$ibeTodayDate,
			beforeShowDay:  $highlightDays,
			dateFormat:    	'd M yy',
			maxDate:      	$ibeMaxLimitDate,
			numberOfMonths: $ipad_not,
			firstDay: 			1,
			beforeShow: function(ele:any, obj:any) {
				_self.$scope.find('#ui-datepicker-div').removeClass('multicityTrip');
				$curDatepickerInst  = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
			},
			afterShow: function() {
				_self.bookingFormCommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			}
		})
		.on('change', function() {
			$returnDate.datepicker('option', 'minDate', getDate(this));
			let $nextReturnDate:any = $(this).next('.returnDate');
			// console.log($nextReturnDate);

			// if return date == empty, focus on field
			if ($nextReturnDate.val() === "") {
				window.setTimeout($.proxy(function() {
					$nextReturnDate.focus();
				}, this), 100);
			} else {
				// do stuff
			}
		});

		let $returnDate = _self.$scope.find('.returnDate').datepicker({
			showButtonPanel: true,
			closeText:    	'<i class="fa fa-times" aria-hidden="true"></i>',
			dateFormat:   	'd M yy',
			minDate:      	$ibeTodayDate,
			maxDate:      	$ibeMaxLimitDate,
			beforeShowDay:	$highlightDays,
			numberOfMonths: $ipad_not,
			firstDay: 			1,
			beforeShow: function(ele:any, obj:any) {
				_self.$scope.find('#ui-datepicker-div').removeClass('multicityTrip');
				_self.bookingFormCommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
				$curDatepickerInst  = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
			},
			afterShow: function() {
				_self.bookingFormCommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			}
		})
		.on('change', function() {
			// $departDate.datepicker('option', 'maxDate', getDate(this));
		});

		/**
		 * Parse single date datepicker value from element
		 */
		let getDate:any = ($element: any) => {
			let $getDate: any;
			try {
				$getDate = $.datepicker.parseDate($dateFormat, $element.value);
			} catch(error) {
				console.error(error);
				$getDate = null;
			}
			return $getDate;
		}

		// Hightlight Datepicker TD colours
		_self.$scope.find('#ui-datepicker-div').on('mouseover','td', () => {
			if (_self.$scope.find('.trip-type--container .returnTrip').hasClass('selected') &&
				_self.$scope.find('.departureDate').val()) {
				let _datepicker:any = $(this);
				_datepicker.parent().addClass('finalRow');

				$('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
				_datepicker.prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

				if (_datepicker.parents().eq(3).hasClass('ui-datepicker-group-last')) {
					$('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
				}
			}
		});

		// On mouseout remove highlight colours
		_self.$scope.find('#ui-datepicker-div').on('mouseout','td', () => {
			$(this).parent().removeClass('finalRow');
			_self.$scope.find('#ui-datepicker-div td').removeClass('highlight');
		});
	}

	dealsResultSubmit(): any {
		let _self = this;
		$('.deals-book--now').click(function(evt:any){
			_self.dealsResultSubmissionLogic(evt, 'desktop');
		});
	}

	post_to_url(path:any, params:any):void {
		let method = "post";
		let form = document.createElement("form");

		form.setAttribute("method", method);
		form.setAttribute("action", path);

		for (let key in params) {
			if(params.hasOwnProperty(key)) {
				let hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		form.submit();
	}

	getUrlVars(url:string):any {
		let vars:Array<any> = [];
		let hash:any;
		let hashes = url.slice(url.indexOf('?') + 1).split('&');
		for(let i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}


	dealsResultValue(device?:string): void {
		let _self = this;
		let isUkCitySelectedForIbeSearch: boolean = false;
		let ukCities: any;
        let $isEnableCNN: any = $('#isEnableCNN');
        if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
            ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
        }
        else {
            ukCities = [];
        }		
    // let $dealsCurrency = $('.currency-price .currency-name').html(),
    // let $dealsTravelCharge = $('.currency-price .price-amount').html(),
		let $fromLocation = $('.city-country--list.from .city-name').attr("data-code");
		let $officeCode   = $('.city-country--list.from .country-name').html();
		let $toLocation   = $('.city-country--list.to .city-name').attr("data-code");
		let $tripType     = $('.deals-popup .trip-type').html();
		let $getDepartureDate = $('.calendar-container .departureDate').val();
		let $departureDate    = moment($getDepartureDate).format('YYYYMMDDhhmm');
		let $getReturnDate    = $('.calendar-container .returnDate').val();
		let $returnDate       = moment($getReturnDate).format('YYYYMMDDhhmm');
    // let $couponCode = $('.couponcode-input').val();
		let $cabinClass = $('.deals-popup #cabin-class-hidden').html();
        let $adultSel:any,$teenagerSel:any, $youthSel:any, $childSel:any, $infantSel:any;
		let $adultSelectedEle  = parseInt($('#passenger-details--deals .passengersAdult').val());
		let $teenagerSelectedEle  = parseInt($('#passenger-details--deals .passengersTeenager').val());
		let $youthSelectedEle  = parseInt($('#passenger-details--deals .passengersYouth').val());
		let $childSelectedEle  = parseInt($('#passenger-details--deals .passengersChildren').val());
		let $infantSelectedEle = parseInt($('#passenger-details--deals .passengersInfant').val());

    if($tripType =="One-way") {
    	$tripType="O";
    } else {
    	$tripType="R";
    }
   
    if($cabinClass == "First") {
    	$cabinClass = "CFFFIRST";
    } else if ($cabinClass.toLowerCase() == "business") {
    	$cabinClass = "CFFBUS";
    } else {
    	$cabinClass = "CFFECO";
    }
	var $data:any = {}

    	 $data = {
    		ARRANGE_BY: 'R',
    		BOOKING_FLOW: 'REVENUE',
    		B_ANY_TIME_1: 'TRUE',
    		B_ANY_TIME_2: 'TRUE',
    		B_DATE_1: ($departureDate == 'Invalid date' ? '' : $departureDate),
    		B_DATE_2: ($returnDate == 'Invalid date' ? '' : $returnDate),
    		B_LOCATION_1: $fromLocation,
    		B_LOCATION_2: $toLocation,
    		COMMERCIAL_FARE_FAMILY_1: $cabinClass,
    		COMMERCIAL_FARE_FAMILY_2: '',
    		COMMERCIAL_FARE_FAMILY_3: '',
    		DATE_RANGE_QUALIFIER_1: 'C',
    		DATE_RANGE_QUALIFIER_2: 'C',
    		DATE_RANGE_VALUE_1: '3',
    		DATE_RANGE_VALUE_2: '3',
    		DISPLAY_TYPE: '2',
    		EMBEDDED_TRANSACTION: 'FlexPricerAvailability',
    		EXTERNAL_ID: 'BOOKING',
    		E_LOCATION_1: $toLocation,
    		E_LOCATION_2: $fromLocation,
    		HAS_INFANT_1: 'FALSE',
    		HAS_INFANT_2: 'FALSE',
    		HAS_INFANT_3: 'FALSE',
    		HAS_INFANT_4: 'FALSE',
    		HAS_INFANT_5: 'FALSE',
    		HAS_INFANT_6: 'FALSE',
    		HAS_INFANT_7: 'FALSE',
    		HAS_INFANT_8: 'FALSE',
    		HAS_INFANT_9: 'FALSE',
    		PRICING_TYPE: 'O',
    		REFRESH: '0',
    		SITE: 'desktop',
    		SO_GL: '',
    		SO_SITE_OFFICE_ID: $officeCode,
    		SO_SITE_QUEUE_OFFICE_ID:$officeCode,
    		TRAVELLER_TYPE_1: '',
    		TRAVELLER_TYPE_2: '',
    		TRAVELLER_TYPE_3: '',
    		TRAVELLER_TYPE_4: '',
    		TRAVELLER_TYPE_5: '',
    		TRAVELLER_TYPE_6: '',
    		TRAVELLER_TYPE_7: '',
    		TRAVELLER_TYPE_8: '',
    		TRAVELLER_TYPE_9: '',
    		TRIP_FLOW: 'YES',
    		TRIP_TYPE: $tripType,
    		ADULT_COUNT: $adultSelectedEle,
    		CHILD_COUNT:   $childSelectedEle,
    		YOUTH_COUNT: $youthSelectedEle,
    		INFANT_COUNT:  $infantSelectedEle
		};
		var $totalTraveller = $adultSelectedEle + $youthSelectedEle + $childSelectedEle+$teenagerSelectedEle;
		var $index = 1;
		for ($adultSel = 1; $adultSel <= $adultSelectedEle; $adultSel++) {
			var $value = 'ADT';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		for ($teenagerSel = 1; $teenagerSel <= $teenagerSelectedEle; $teenagerSel++) {
			var $value = 'CNN';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
		if($('#passenger-details--deals .teenager-cat').css('display')==="block")
		{
			$data['TEENAGER_COUNT'] = $teenagerSelectedEle;
		}
		for ($youthSel = 1; $youthSel <= $youthSelectedEle; $youthSel++) {
			var $value = 'B15';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
	
		for ($childSel = 1; $childSel <= $childSelectedEle; $childSel++) {
			var $value = 'CHD';
			$data['TRAVELLER_TYPE_' + $index] = $value;
			$index++;
		}
	
		for ($infantSel = 1; $infantSel <= $infantSelectedEle; $infantSel++) {
			var $infant_value = 'TRUE';
			$data['HAS_INFANT_' + $infantSel] = $infant_value;
		}
		
		/* Amadeus adobe partnership variable settings */
		// let $amcvId;
		// 	$amcvId = Visitor.getInstance("4D9676A8531512ED0A490D44").getMarketingCloudVisitorID();
		// 	$data['AMCVID_ECID'] = $amcvId;
		let $tripFlowUrl;
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*phantom\\s*=\\s*([^;]+)');
		if (loginTokenCookieVal != null) {
			 // find login status here
			 let $param = {
				'flyerId': "",
				'payby': 'cashcard',
				'gts_index':""
			};
	
			$.ajax({
				type: 'POST',
				url: '/bin/services/new/retrievemember',
				data: $param,
				success: function(json:any) {
					json = JSON.parse(json);
					var directLoginParameters = json.directLoginParameters;
					$tripFlowUrl = $.param($data) + "&"+ directLoginParameters;
					_self.ibeCallback($tripFlowUrl);
				},
				error: function(error:any) {
					console.log("Error while getting member info", error);
				}
			});

		}else{
			 $tripFlowUrl = $.param($data);
			 _self.ibeCallback($tripFlowUrl);
		}
 
 }

  ibeCallback($tripFlowUrl:any): void {
	let _self = this;
    console.log("tripFlowUrl:" + $tripFlowUrl);
    var $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
    console.log("tripflow_encryptURL:" + $tripflow_encryptURL);
    // Use JQuery AJAX request to post data to a Sling Servlet
    $.ajax({
    	type: 'POST',
    	url:'/bin/services/new/ibe',
    	data:'url='+ $tripflow_encryptURL,
    	success: function(msg:any){
    		console.log("##Successful: " + msg);

    		var json = msg;
    		if(json.success =="false") {
    			console.log("Error while submitting form" + json);
    			$('.deals-error--validation').show();
    			$('.deals-validator').text("Error while submitting form");
    		} else {
    			console.log("##Redirect URL: "+ json.url);
		  	  // window.location.replace(json.url);
		  	  var responseUrl = json.url;
		  	  var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
		  	  _self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
		  	}
		  },
		  error: function(error:any) {
		  	$('.deals-error--validation').show();
		  	$('.deals-validator').text("Error while submitting form");
		  }
		});
	}
	dealsTandC(): void {
		$('.terms-and-conditons h6').click(function() {
			$('.tc-content').toggle();
			if($('.tc-content').css('display') == 'none'){
				$('.terms-and-conditons h6 .fa.fa-angle-down').show();
				$('.terms-and-conditons h6 .fa.fa-angle-up').hide();
			} else {
				$('.terms-and-conditons h6 .fa.fa-angle-down').hide();
				$('.terms-and-conditons h6 .fa.fa-angle-up').show();
			}
		});
	}

	mobileSubmitFormHandler(): void {
		let _self = this;
		// let formDataWhichFail:any = [];
		if ( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			console.log("Mobile Device");
			$('.mobDeals-book--now').click((evt:any) => {
				evt.preventDefault();
				console.log("Mobile Device Submission");
				_self.dealsResultSubmissionLogic(evt, "mobile");
			});
		}
	}

	dealsResultSubmissionLogic(evt:any, device:string): void {
		let _self = this;
		console.log("This is the device clicked ::"+device);

		evt.preventDefault();
		let $dealsResultErrorDiv : any = $('.deals-error--validation');
		let $dealsResultValidator: any = $('.deals-validator');
		let $dealsDepDate:any = $('.calendar-container .departureDate');
		let $dealsRetDate:any = $('.calendar-container .returnDate');
		let $dealsAdtPass: any = $('#passenger-details--deals .passengersAdult').val();
		let $dealsInfPass: any = $('#passenger-details--deals .passengersInfant').val();
		let $moreInfantError: any = $('.infant-booking--error');
		let $validationSuccess    : any = true;
		_self.$dealsResultError = [];
		$dealsResultErrorDiv.show();

		if($dealsDepDate.val() == ''){
			let $dealsDepDateValidate:any = $dealsDepDate.attr('data-travelDepdate');
			_self.$dealsResultError.push('<strong>'+$dealsDepDate.parent().find('label').text()+':</strong> '+$dealsDepDateValidate);
			$dealsDepDate.parent().addClass('has-error');
			$dealsDepDate.parent().find('.booking-form--title').addClass('has-error');
			$validationSuccess = false;
		} else {
			$dealsDepDate.parent().removeClass('has-error');
			$dealsDepDate.parent().find('.booking-form--title').removeClass('has-error');
		}

		if($dealsRetDate.val() == ''){
			let $dealsRetDateValidate:any = $dealsRetDate.attr('data-travelRetdate');
			_self.$dealsResultError.push('<strong>'+$dealsRetDate.parent().find('label').text()+':</strong> '+$dealsRetDateValidate);
			$dealsRetDate.parent().addClass('has-error');
			$dealsRetDate.parent().find('.booking-form--title').addClass('has-error');
			$validationSuccess = false;
		} else {
			$dealsRetDate.parent().removeClass('has-error');
			$dealsRetDate.parent().find('.booking-form--title').removeClass('has-error');
		}

		if($dealsInfPass > $dealsAdtPass){
			let $adultInfantError: any = $moreInfantError.attr('data-moreinfant');
			_self.$dealsResultError.push('<strong>Passenger:</strong> '+$adultInfantError);
			$validationSuccess = false;
		}

		let $validationContainer:any = $dealsResultValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=_self.$dealsResultError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + _self.$dealsResultError[i] + '</li>');
		}

		if($validationSuccess) {
			$dealsResultErrorDiv.hide();
			console.log('Success');
			_self.dealsResultValue(device);
		}
	}

}

let scope:Element = document.querySelector('#deals-popup');
if (scope){
	try {
	let dealsresult = new dealsResult();
			dealsresult.passengerDetails();
			dealsresult.calendarComponent();
			dealsresult.dealsResultSubmit();
			dealsresult.dealsTandC();
			dealsresult.mobileSubmitFormHandler();
	
	} catch(e) {console.error(e);}
}